import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
// services
import { ErrorHandler } from '../../../shared/services/error-handler.service';
declare var ga: any;

@Component({
  selector: 'app-validate-email-section',
  templateUrl: './validate-email-section.component.html',
  styleUrls: ['./validate-email-section.component.scss'],
  providers: [ErrorHandler]
})
export class ValidateEmailSectionComponent implements OnInit {

  // public showEmailSent: Boolean = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      ga('set', 'page', '/validate-email');
      ga('send', 'pageview');
    }
  }

}
